<template>
  <main class="login-page">
    <section class="login-card" aria-labelledby="login-title">
      <header class="login-header">
        <img src="@/assets/images/lengedu.jpg" alt="Lengedu" class="login-logo">
        <span class="login-eyebrow">ÖĞRENCİ PANELİ</span>
        <h1 id="login-title">Tekrar hoş geldiniz</h1>
        <p>İngilizce yolculuğunuza kaldığınız yerden devam edin.</p>
      </header>
      <form class="login-form" @submit.prevent="submit" :aria-busy="form.isLoading">
        <div class="login-field">
          <label for="email">E-posta adresi</label>
          <input id="email" v-model="form.username" type="email" placeholder="ornek@eposta.com" autocomplete="username" inputmode="email" required>
        </div>
        <div class="login-field">
          <label for="password">Parola</label>
          <input id="password" v-model="form.password" type="password" class="ym-disable-keys" placeholder="Parolanızı girin" autocomplete="current-password" required>
        </div>
        <div class="login-options">
          <label class="remember-option" for="remember">
            <input id="remember" v-model="form.rememberMe" type="checkbox">
            <span>Beni hatırla</span>
          </label>
          <router-link to="/forgot-password">Parolamı unuttum</router-link>
        </div>
        <button class="login-submit" type="submit" :disabled="form.isLoading">
          <span v-if="form.isLoading" class="login-spinner" aria-hidden="true"></span>
          <span aria-live="polite">{{ form.isLoading ? 'Giriş yapılıyor…' : 'Giriş yap' }}</span>
          <span v-if="!form.isLoading" aria-hidden="true">→</span>
        </button>
      </form>
      <p class="login-register">Henüz hesabınız yok mu? <router-link to="/register">Kayıt olun</router-link></p>
    </section>
    <footer class="login-footer"><VersionNumber /></footer>
  </main>
</template>

  <script>
  import { mapActions } from "vuex";
  import { LoadingToast,UpdateToast,RemoveToast,ToastType } from "@/common/notification.js";
  import VersionNumber from "@/components/Shared/VersionNumber.vue";
  export default {
    name: "LoginPage",
    components: {
      VersionNumber
    },
    data() {
      return {
        form: {
          username: "",
          password: "",
          rememberMe:false,
          isLoading:false
        }
      };
    },
    methods: {
      ...mapActions(["LogIn"]),
      async submit() {
        if (this.form.isLoading) return;
        let toastId = LoadingToast();
        this.form.isLoading=true;
        this.SaveLocalStorage();
        const user = {
          "UserName": this.form.username,
          "Password": this.form.password,
          "PanelType": 2
        };
        await this.LogIn(user)
        .then(()=>{
          this.form.isLoading=false;
          RemoveToast(toastId);
          this.$router.replace("/");
        })
        .catch(err=>{
          UpdateToast(toastId,err.message,ToastType().ERROR);
          this.form.isLoading=false;
        });
      },
      SaveLocalStorage(){
        if (this.form.rememberMe) {
          localStorage.rememberUsername = this.form.username;
          localStorage.rememberCheck = true;
        } else {
          localStorage.rememberUsername = "";
          localStorage.rememberCheck = "";
        }
      },
      CheckRemember(){
        if (localStorage.rememberCheck && localStorage.rememberCheck !== "") {
          this.form.rememberMe = true;
          this.form.username = localStorage.rememberUsername;
        } else {
          this.form.rememberMe = false;
          this.form.username = '';
        }
      }
    },
    mounted: function() {
      this.CheckRemember();
    }
  };
  </script>
  
<style scoped>
.login-page {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 20px 24px;
  background: radial-gradient(ellipse at 50% 0%, #e7f2e9 0%, transparent 60%), #f6f8f7;
  color: #20372b;
}
.login-card { width: 100%; max-width: 440px; padding: 40px; background: #fff; border: 1px solid #e4ebe6; border-radius: 24px; box-shadow: 0 16px 48px -24px rgb(31 63 44 / 22%); }
.login-header { text-align: center; }
.login-logo { display: block; width: 160px; max-width: 100%; height: auto; margin: 0 auto 28px; }
.login-eyebrow { display: block; margin-bottom: 12px; color: #53745f; font-size: 11px; font-weight: 700; letter-spacing: 2px; }
.login-header h1 { margin: 0 0 10px; font-size: 27px; font-weight: 700; letter-spacing: -0.8px; line-height: 1.25; }
.login-header p { margin: 0 auto; max-width: 290px; color: #69776e; font-size: 14px; line-height: 1.65; }
.login-form { margin-top: 30px; }
.login-field + .login-field { margin-top: 18px; }
.login-field label { display: block; margin-bottom: 8px; font-size: 13px; font-weight: 600; }
.login-field input { width: 100%; min-height: 50px; padding: 12px 14px; border: 1px solid #dbe4de; border-radius: 10px; background: #fbfcfb; color: #20372b; font: inherit; font-size: 14px; transition: border-color 150ms, box-shadow 150ms; }
.login-field input::placeholder { color: #7c8980; }
.login-field input:focus { outline: none; border-color: var(--brand-primary); background: #fff; box-shadow: 0 0 0 3px rgb(79 183 72 / 13%); }
.login-options { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; margin: 20px 0 24px; font-size: 12px; }
.remember-option { display: inline-flex; align-items: center; gap: 8px; color: #637167; cursor: pointer; }
.remember-option input { width: 16px; height: 16px; margin: 0; accent-color: var(--brand-primary); }
.login-card a { color: var(--brand-link); font-weight: 600; text-decoration: none; }
.login-card a:hover { text-decoration: underline; }
.login-card a:focus-visible, .login-submit:focus-visible, .remember-option input:focus-visible { outline: 3px solid #71ac7c; outline-offset: 4px; }
.login-submit { display: flex; align-items: center; justify-content: center; gap: 12px; width: 100%; min-height: 50px; padding: 12px 18px; border: 0; border-radius: 10px; background: var(--brand-primary); color: #fff; font-size: 14px; font-weight: 600; transition: background 150ms; }
.login-submit:hover:not(:disabled) { background: var(--brand-primary-hover); }
.login-submit:disabled { opacity: 0.7; cursor: wait; }
.login-spinner { width: 16px; height: 16px; border: 2px solid rgb(255 255 255 / 35%); border-top-color: #fff; border-radius: 50%; animation: login-spin 800ms linear infinite; }
.login-register { margin: 28px 0 0; padding-top: 24px; border-top: 1px solid #edf1ee; text-align: center; color: #69776e; font-size: 13px; line-height: 1.8; }
.login-register a { display: inline-block; margin-left: 4px; }
.login-footer { margin-top: 12px; font-size: 13px; }
@keyframes login-spin { to { transform: rotate(360deg); } }
@media (max-width: 480px) {
  .login-page { padding: 24px 16px 16px; }
  .login-card { padding: 30px 24px; border-radius: 20px; }
  .login-header h1 { font-size: 25px; }
}
@media (prefers-reduced-motion: reduce) {
  .login-field input, .login-submit { transition: none; }
  .login-spinner { animation: none; }
}
</style>